import React from 'react';
import { StudyGuideMyGuideDataGrid } from './study-guide-my-guide-data-grid';
import { DialogContent, DialogTitle } from '@/components/ui/dialog';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';

export function StudyGuideMyGuideModal(props) {
  const { data } = props;
  const playful = usePlayfulStudent();

  return (
    <DialogContent size="lg">
      <DialogTitle style={playful ? { color: 'var(--color-secondary)' } : undefined}>Interação com o guia</DialogTitle>

      <StudyGuideMyGuideDataGrid
        data={data}
        height={366}
      />
    </DialogContent>
  );
}
